import React, { useCallback, useState, Fragment } from 'react'
import { CircleSpinner } from 'react-spinners-kit'
import { mdiArrowDown, mdiArrowUp, mdiCog, mdiDelete, mdiPencil, mdiPlusCircle } from '@mdi/js'
import { LinksTutoriaisListaType } from '../types'
import TableListarItens from './TableListarItens'
import { SectionOption } from '../../../../components/Section'

interface Props {
    lista: LinksTutoriaisListaType[] | null
    loading: boolean
    canEditLista: boolean
    isAdmin: boolean
    canEditItem: (idLista: number) => boolean
    onConfigurarLista: (lista: LinksTutoriaisListaType) => void
    onEditarLista: (lista: LinksTutoriaisListaType) => void
    onRemoverLista: (lista: LinksTutoriaisListaType) => void
    onCriarItem: (lista: LinksTutoriaisListaType) => void
    onEditarItem: (lista: LinksTutoriaisListaType, item: any) => void
    onRemoverItem: (lista: LinksTutoriaisListaType, item: any) => void
    onMoverLista: (index: number, direcao: 'up' | 'down') => void
}

const AgrupamentoComponent: React.FC<Props> = ({
    lista, loading, canEditLista, isAdmin, canEditItem,
    onEditarLista, onRemoverLista, onConfigurarLista,
    onCriarItem, onEditarItem, onRemoverItem, onMoverLista
}) => {
    const SHOW_LOADING = loading
    const SHOW_TABLE = !!lista && !SHOW_LOADING && lista.length > 0
    const [listaIndex, setListaIndex] = useState<number[]>([])

    const handleToggle = useCallback((index: number) => {
        let novaListaId = [...listaIndex]
        if (!listaIndex.includes(index)) {
            novaListaId.push(index)
        } else {
            novaListaId.splice(listaIndex.indexOf(index), 1)
        }
        setListaIndex([...novaListaId])
    }, [listaIndex])

    return (
        <>
            {SHOW_TABLE && (
                <div className="container">
                    <div className="accordion" id="accordionLinksTutoriais">
                        {lista?.map((item, index) => (
                            <Fragment key={item.id}>
                                <div className="sectionBox">
                                    <h2 className="sectionBoxHeader">
                                        <button
                                            className={`sectionBoxHeaderOption accordion-button ${listaIndex?.includes(index) ? "collapsed" : ""}`}
                                            type="button"
                                            onClick={() => handleToggle(index)}
                                        >
                                            {`${item.nome} — Criado em: ${new Date(item.dtCadastro).toLocaleDateString()}`}
                                        </button>
                                        {(canEditLista || isAdmin) && (
                                            <span style={{ display: 'inline-flex', gap: '4px', marginLeft: '8px' }}>
                                                {isAdmin && (
                                                    <SectionOption icon={mdiCog} tooltip="Configurar permissões" onClick={() => onConfigurarLista(item)} />
                                                )}
                                                {canEditLista && (
                                                    <>
                                                <SectionOption icon={mdiArrowUp} tooltip="Mover para cima" onClick={() => onMoverLista(index, 'up')} />
                                                <SectionOption icon={mdiArrowDown} tooltip="Mover para baixo" onClick={() => onMoverLista(index, 'down')} />
                                                <SectionOption icon={mdiPencil} tooltip="Editar lista" onClick={() => onEditarLista(item)} />
                                                <SectionOption icon={mdiDelete} tooltip="Remover lista" onClick={() => onRemoverLista(item)} />
                                                {canEditItem(item.id) && (
                                                    <SectionOption icon={mdiPlusCircle} tooltip="Adicionar link" onClick={() => onCriarItem(item)} />
                                                )}
                                                    </>
                                                )}
                                            </span>
                                        )}
                                    </h2>
                                    <div className={`accordion-collapse collapse ${listaIndex?.includes(index) ? "show" : ""}`}>
                                        <div className="accordion-body">
                                            <TableListarItens
                                                lista={item.dados}
                                                loading={loading}
                                                canEdit={canEditItem(item.id)}
                                                onEditar={(row) => onEditarItem(item, row)}
                                                onRemover={(row) => onRemoverItem(item, row)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        ))}
                    </div>
                </div>
            )}
            {SHOW_LOADING && (
                <div>
                    <CircleSpinner size={32} color="grey" />
                </div>
            )}
            {!SHOW_LOADING && (!lista || lista.length === 0) && (
                <div style={{ padding: '16px' }}>Nenhuma lista encontrada.</div>
            )}
        </>
    )
}

export default AgrupamentoComponent
